import { Box, Card, Stack, Text, Title } from '@mantine/core';
import type { ReactNode } from 'react';

import { accentFill } from '../theme';

interface AuthCardProps {
  title: string;
  description?: string;
  width?: number;
  children: ReactNode;
}

/** Общая рамка страниц входа, регистрации и восстановления пароля. */
export function AuthCard({ title, description, width = 430, children }: AuthCardProps) {
  return (
    <Card padding="xl" maw={width} mx="auto" mt={{ base: 0, sm: 'xl' }}>
      <Stack gap="lg">
        <Stack gap="xs">
          <Title
            order={2}
            fz={20}
            c="graphite.9"
            style={{ textTransform: 'uppercase', letterSpacing: '0.08em' }}
          >
            {title}
          </Title>

          <Box w={36} h={3} bg={accentFill} style={{ borderRadius: 2 }} />

          {description !== undefined && (
            <Text c="graphite.6" size="sm" mt={4}>
              {description}
            </Text>
          )}
        </Stack>

        {children}
      </Stack>
    </Card>
  );
}
